if (!customElements.get('ss-product-image-viewer')) {
  customElements.define('ss-product-image-viewer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized || typeof HTMLDialogElement === 'undefined') return;
      this.root = this.closest('.product_page_template');
      if (!this.root) return;
      this.images = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.dialog = this.querySelector('dialog');
      this.stage = this.querySelector('.ss-image-dialog__stage');
      this.previous = this.querySelector('[data-image-previous]');
      this.next = this.querySelector('[data-image-next]');
      this.position = this.querySelector('[data-image-position]');
      this.selector = '.product-images-static img, .product-images-col img.zoom-product, .tt-product-single-img .mediaimageholder img.zoom-product, .tt-mobile-product-slider img';
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.initialized = true;
      document.documentElement.classList.add('ss-product-image-viewer-ready');
      const enhance = () => this.root.querySelectorAll(this.selector).forEach(image => {
        if (this.imageIndex(image) < 0) return;
        image.setAttribute('data-image-viewer-trigger', '');
        image.setAttribute('role', 'button');
        image.setAttribute('tabindex', image.closest('.slick-cloned, [aria-hidden="true"]') ? '-1' : '0');
        image.setAttribute('aria-haspopup', 'dialog');
        image.setAttribute('aria-label', this.dataset.openLabel + ': ' + (image.alt || this.dialog.getAttribute('aria-label')));
      });
      enhance();
      this.observer = new MutationObserver(enhance);
      this.root.querySelectorAll('.product-images-static, .product-images-col, .tt-product-single-img, .tt-mobile-product-slider').forEach(gallery => {
        this.observer.observe(gallery, {childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden']});
      });
      this.root.addEventListener('pointerdown', event => { this.pointer = {x: event.clientX, y: event.clientY}; }, {signal, passive: true});
      this.root.addEventListener('click', event => {
        const image = event.target.closest(this.selector);
        if (!image || this.imageIndex(image) < 0) return;
        if (this.pointer && (Math.abs(event.clientX - this.pointer.x) > 8 || Math.abs(event.clientY - this.pointer.y) > 8)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.open(image);
      }, {signal, capture: true});
      this.root.addEventListener('keydown', event => {
        if (!['Enter', ' '].includes(event.key) || !event.target.matches(this.selector)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.open(event.target);
      }, {signal, capture: true});
      this.querySelector('[data-image-close]').addEventListener('click', () => this.dialog.close(), {signal});
      this.previous.addEventListener('click', () => this.show(this.index - 1), {signal});
      this.next.addEventListener('click', () => this.show(this.index + 1), {signal});
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      }, {signal});
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.oldOverflow;
        this.stage.replaceChildren();
        if (this.trigger?.isConnected) this.trigger.focus({preventScroll: true});
      }, {signal});
    }
    imageKey(source) {
      try { return new URL(source, location.href).pathname.split('/').pop().replace(/_\d+x\d*(?:_crop_[a-z]+)?(?=\.[a-z]+$)/i, ''); }
      catch { return ''; }
    }
    imageIndex(image) {
      const sources = [image.getAttribute('data-zoom-image'), image.currentSrc, image.getAttribute('src'), image.getAttribute('srcset')?.split(/[ ,]/)[0]].filter(Boolean).map(source => this.imageKey(source));
      for (const source of sources) {
        const index = this.images.findIndex(item => source === this.imageKey(item.src));
        if (index >= 0) return index;
      }
      return -1;
    }
    open(image) {
      const index = this.imageIndex(image);
      if (index < 0 || this.dialog.open) return;
      this.trigger = image;
      this.oldOverflow = document.documentElement.style.overflow;
      this.show(index);
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    show(index) {
      if (index < 0 || index >= this.images.length) return;
      this.index = index;
      const image = new Image();
      image.alt = this.images[index].alt;
      image.src = this.images[index].src;
      this.stage.replaceChildren(image);
      this.position.textContent = (index + 1) + ' / ' + this.images.length;
      this.previous.disabled = index === 0;
      this.next.disabled = index === this.images.length - 1;
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.observer?.disconnect();
      this.initialized = false;
    }
  });
}
